<template>
  <transition name="router-anim">
    <div>
      <section class="info-block-wrapper search">
        <div class="title search">
          <span>Search Kit</span>
        </div>
        <div class="input-div-wrap">
          <div class="input-wrap">
            <input
              v-mask="'XX - XX - XXX - XXXX'"
              id="kit-id"
              type="text"
              class="input"
              placeholder="Enter Kit ID"
              name="kit_id"
              v-model="kit_id"
              @paste="paste"
              v-validate="{ required: true, length: 20 }"
            />
            <span class="validate-error position" v-if="errors.has('kit_id')">
              {{ setError(errors.first("kit_id")) }}
            </span>
          </div>
          <div class="input-wrap">
            <input
              v-mask="'XX - XX - XXX - XXXX'"
              id="kit-verify"
              type="text"
              class="input"
              placeholder="Confirm Kit ID"
              name="confirm_kit_id"
              v-model="confirm_kit_id"
              @paste="paste"
              v-validate="{ required: true, is: kit_id }"
            />
            <span
              class="validate-error bottom-position position"
              v-if="errors.has('confirm_kit_id')"
            >
              {{ errors.first("confirm_kit_id") }}
            </span>
          </div>
          <div>
              <button
                class="btn btn-test search"
                @click.stop="stopPropagation"
                @click.prevent="$validator.validateAll()"
                @click="sendsearchReq"
                :disabled="!isComplete"
              >
                Search
              </button>
          </div>
        </div>
      </section>
      <section class="info-block-wrapper" v-if="kits.length > 0 || contactAdminStatus">
        <div v-if="kits.length > 0 && kits[0].status !== 'archive'">
          <div class="title">
            <span>Test Kit Information</span>
            <div class="id">
              <span style="padding: 1.5px 0 0 0">KIT ID: {{ convertKitId(kits[0].kit_id)}}</span>
            </div>
          </div>
          <div class="date-wrap">
            <div class="col">
              <div class="item">
                <div class="item-title">Status</div>
                  <div class="item-val">
                    <div
                      class="kit-desc status"
                      :style="
                        kits[0].status === 'on_hold' ? { color: 'rgb(232, 122, 1)' } : null
                      "
                    >
                    <span class="onHoldStatus" v-if="kits[0].status === 'on_hold'">
                      On Hold
                      <button
                        @click.stop="stopPropagation"
                        class="onhold-btn"
                      >
                        <img
                          class="onhold-btn-img"
                          src="../../images/dashboard/onhold.png"
                          alt="#"
                        />
                      </button>
                    </span>
                    <span v-if="kits[0].status === 'analysis_completed'"
                      >Analysis Complete</span
                    >
                    <span v-if="kits[0].status === 'analysis_failed'"
                      >Analysis Failed</span
                    >
                    <span v-if="kits[0].status === 'lab_received'">Lab Received</span>
                    <span v-if="kits[0].status === 'lab_awaiting'">Submitted</span>
                    <span v-if="kits[0].status === 'shipped'">Shipped</span>
                    <span v-if="kits[0].status === 'activated'">Activated</span>
                    <span v-if="kits[0].status === 'delivered'">Delivered</span>
                    <div
                      class="status-line"
                      :style="
                        kits[0].status === 'on_hold'
                          ? { backgroundColor: 'rgba(232, 122, 1, .4)' }
                          : null
                      "
                    >
                      <div
                        class="status-line-bg"
                        :style="[
                          kits[0].status === 'shipped' ? { width: '16.6%' } : null,
                          kits[0].status === 'delivered' ? { width: '28.6%' } : null,
                          kits[0].status === 'activated' ? { width: '49.8%' } : null,
                          kits[0].status === 'lab_awaiting' ? { width: '66.4%' } : null,
                          kits[0].status === 'lab_received' ? { width: '83%' } : null,
                          kits[0].status === 'on_hold'
                            ? { width: '83%', backgroundColor: '#E87A01' }
                            : null,
                          kits[0].status === 'analysis_failed'
                            ? { width: '100%', backgroundColor: 'red' }
                            : null,
                          kits[0].status === 'analysis_completed' ? { width: '100%' } : null
                        ]"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col" v-if="kits[0].status == 'on_hold'">
              <div class="item">
                <div class="item-title">Reason on hold</div>
                <div class="item-val">
                  {{ kits[0].reason_on_hold }}
                </div>
              </div>
            </div>
            <div class="col" v-if="kits[0].status == 'on_hold'">
              <div class="item">
                <div class="item-title">On hold at</div>
                <div class="item-val">
                  {{ convertDate(kits[0].onhold_at) }}
                </div>
              </div>
            </div>
          </div>
          <div class="not-activated-notice" v-if="isNotActivated">
            <span class="warning-icon">⚠</span>
            This kit needs to be activated — no customer is assigned.
          </div>
          <div class="title">
            <span>Customer Information</span>
          </div>
          <div class="date-wrap2">
            <div class="col">
              <div class="item">
                <div class="item-title">First Name</div>
                <div class="item-val" v-if="kits[0].user !== null">
                  {{ kits[0].user.first_name }}
                </div>
              </div>
            </div>
            <div class="col">
              <div class="item">
                <div class="item-title">Last Name</div>
                <div class="item-val" v-if="kits[0].user !== null">
                  {{ kits[0].user.last_name }}
                </div>
              </div>
            </div>
            <div class="col">
              <div class="item">
                <div class="item-title">Email</div>
                <div class="item-val" v-if="kits[0].user !== null">
                  {{ kits[0].user.email }}
                </div>
              </div>
            </div>
            <div class="col">
              <div class="item" v-if="kits[0].activated_at">
                <div class="item-title">Date Of Activation</div>
                <div class="item-val">
                  {{ convertDate(kits[0].activated_at) }}
                </div>
              </div>
              <div class="item" v-else>
                <div class="item-title">Date Of Purchase</div>
                <div class="item-val">
                  {{ convertDate(kits[0].user.created_at) }}
                </div>
              </div>
            </div>
            <div class="col">
              <div class="item">
                <div class="item-title">Date Of Last Contact</div>
                <div class="item-val" v-if="kits[0].onhold_contact_count !== 0">
                  {{ convertDate(kits[0].last_contact_date) }}/{{kits[0].onhold_contact_count}}
                </div>
                <div class="item-val" v-else>
                  {{ convertDate(kits[0].last_contact_date) }}
                </div>
              </div>
            </div>
          </div>
          <div class="btn-align" v-if="kits[0].last_contact_date == null && ['shipped', 'delivered'].includes(kits[0].status) && !isNotActivated">
            <button
              v-if="!isNotActivated"
              class="btn btn-test"
              @click="openReviewModal"
              @click.stop="stopPropagation"
            >
              Contact Customer
            </button>
            <span v-else class="no-contact-msg">No email or phone number on file — unable to contact this customer.</span>
          </div>
          <div class="btn-align" v-if="kits[0].last_contact_date == null && kits[0].status == 'activated'">
            <button
              v-if="!isNotActivated"
              class="btn btn-test"
              @click="openReviewModal"
              @click.stop="stopPropagation"
            >
              Contact Customer
            </button>
          </div>
          <div v-if="kits[0].status == 'lab_awaiting'">
            <div>
              <div id="download-button-wrap" class="btn-align">
                <div>
                  <button
                    class="btn btn-test"
                    @click="downloadCsvFile"
                    @click.stop="stopPropagation"
                  >
                    Download CSV
                  </button>
                </div>
              </div>
            </div>
            <div class="btn-align">
              <span class="or-text">In case of download or CSV Failure, please contact us.</span>
            </div>
            <div>
              <div class="title">
                <span>Message</span>
              </div>
              <div> 
                <textarea class="textarea" placeholder="Message" v-model="adminMessage"></textarea>
              </div>
              <div class="btn-align">
                <div>
                  <button
                    class="btn btn-test"
                    @click="openReviewModal"
                    @click.stop="stopPropagation"
                  >
                    Contact Admin
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="contactAdminStatus">
          <div class="title">
            <span>Message</span>
          </div>
          <div> 
            <textarea class="textarea" placeholder="Message" v-model="adminMessage"></textarea>
          </div>
          <div class="kits-item custom">
            <span v-if="kits.length > 0 && kits[0].status == 'archive'"> Kit ID is archived! </span>
            <span v-else> Kit ID is missing! </span>
            <button
              class="btn btn-test"
              @click="openReviewModal"
              @click.stop="stopPropagation"
            >
              Contact Admin
            </button>
          </div>
        </div>
        <ConfirmContactCustomer
          v-if="reviewModal"
          @closeModal="closeReviewModal"
          @submit="contact"
        ></ConfirmContactCustomer>
        <Alert
          v-if="alertModal"
          @closeModal="closeAlertModal"
          :message="message"
        ></Alert>
      </section>
    </div>
  </transition>
</template>

<script>
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import Paginate from "vuejs-paginate";
import moment from "moment";
import axios from "axios";
import { parseAndConvertKitId } from "../mixins/parseAndConvertKitId";
import Remove from "../../images/dashboard/Remove";
import ConfirmContactCustomer from "../dashboard/ConfirmContactCustomer";
import Alert from "../dashboard/Alert";

export default {
  name: "Kits",
  mixins: [parseAndConvertKitId],
  data() {
    return {
      kit_id: null,
      confirm_kit_id: null,
      searchKey: null,
      kits: [],
      count_page: 1,
      sortedByState: "desc",
      reviewModal: false,
      contactAdminStatus: false,
      alertModal: false,
      message: null,
      adminTitle: null,
      adminMessage: null,
      api_url: process.env.VUE_APP_API_URL,
    };
  },
  components: {
    Paginate,
    Remove,
    ConfirmContactCustomer,
    Alert
  },
  methods: {
    changePage(item) {
      this.setPginationPage(item).then(res => {
        this.sendSearchReq();
      });
    },
    ...mapActions([
      "testKitInfo",
      "getUserInfo",
      "setSerachString",
      "sendSearchReq",
      "sendSearchReqLab",
      "setSortedBy",
      "setPginationPage",
      "contactCustomer",
      "contactAdmin",
      "contactCustomerActivated"
    ]),
    setError(str) {
      if (str === "exists validation failed on kit_id") {
        return "Can’t find this Kit ID.";
      }

      if(str === "Your Kit ID is required..") {
        return "Kit ID is required..";
      }
      
      return str;
    },
    paste(e) {
      e.preventDefault();
    },
    validate() {
      this.errors.clear();
    },
    remove(id) {
      this.$emit("confurmDelKit", { show: true, id });
    },
    sortedBy() {
      if (this.sortedByState === "desc") {
        this.sortedByState = "asc";
      } else {
        this.sortedByState = "desc";
      }
      this.setSortedBy(this.sortedByState);
      this.sendSearchReq();
    },
    makePhone(phone) {
      const phoneArr = phone.split("");
      return `(${phoneArr[1]}${phoneArr[2]}${phoneArr[3]}) ${phoneArr[4]}${
        phoneArr[5]
      }${phoneArr[6]}-${phoneArr[7]}${phoneArr[8]}${phoneArr[9]}${
        phoneArr[10]
      }`;
    },
    showModal(kitId, userId, modal) {
      this.testKitInfo(kitId).then(res => {
        if (modal === "kit") {
          if (userId !== null) {
            this.getUserInfo(userId).then(res => {
              this.$emit("showModal", true);
            });
          } else {
            this.$emit("showModal", true);
          }
        } else if (modal === "hold") {
          this.$emit("showComment", {
            txt: this.$store.getters.getTestKitInfo.reason_on_hold,
            show: true,
            id: this.$store.getters.getTestKitInfo.id
          });
        }
      });
    },
    date(localDate) {
      if (localDate !== null) {
        let date = new Date(localDate);
        return date.toLocaleDateString("en-US");
      }
    },
    showReviewModal(boolean) {
      this.reviewModal = boolean;
    },
    closeReviewModal(boolean) {
      this.reviewModal = boolean;
    },
    openReviewModal() {
      this.reviewModal = true;
    },
    closeAlertModal(boolean) {
      this.alertModal = boolean;
    },
    sendsearchReq() {
      this.searchKey = this.parseKitId(this.kit_id);
      this.setSerachString(this.searchKey);
      this.sendSearchReqLab().catch(this.handleRequestError);
      this.kit_id = null;
      this.confirm_kit_id = null;
    },
    handleRequestError(err) {
      this.reviewModal = false;
      this.message =
        err && err.response && err.response.status === 403
          ? 'forbidden'
          : 'requestFailed';
      this.alertModal = true;
    },
    contact() {
      if(this.contactAdminStatus){
        const data = {
          kit_id: this.getSearchString,
          subject: this.adminTitle,
          message: this.adminMessage
        };
        this.contactAdmin(data).then(res => {
          this.message = 'contactAdmin';
          this.alertModal = true;
        }).catch(this.handleRequestError);
      }else{
        if(this.kits[0].status == 'lab_awaiting') {
          const data = {
            kit_id: this.getSearchString,
            subject: 'Problem with Kit ID Sample Data',
            message: this.adminMessage
          };
          this.contactAdmin(data).then(res => {
            this.message = 'contactAdmin';
            this.alertModal = true;
          }).catch(this.handleRequestError);
        } else if (this.kits[0].status == 'activated') {
          const data = {
            kits: this.kits
          };
          this.contactCustomerActivated(data).then(res => {
            this.message = 'contactCustomerActivated';
            this.alertModal = true;
          }).catch(this.handleRequestError);
        }else{
          const data = {
            kits: this.kits
          };
          this.contactCustomer(data).then(res => {
            this.message = 'contactCustomer';
            this.alertModal = true;
          }).catch(this.handleRequestError);
        }
      }
    },
    async downloadCsvFile() {
      await axios({
        url: `${this.api_url}/v1/lab_operator/downloadCsv/${this.searchKey}`,
        method: "GET",
        responseType: "blob"
      })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `${this.convertKitId(this.searchKey)}.csv`
          );
          document.getElementById("download-button-wrap").appendChild(link);
          link.click();
        })
        .catch(errors => {
          this.message = 'problemWithSampleData';
          this.alertModal = true;
        })
    },
    stopPropagation(event) {
      event.stopPropagation();
    },
    convertDate(date) {
      if (date !== null) return moment(date).format("ll");
    }
  },
  computed: {
    ...mapGetters(["serverValidation", "getAdminKits", "pogination", "role", "getSearchString"]),
    isComplete() {
      return (
        this.kit_id && this.confirm_kit_id && this.kit_id === this.confirm_kit_id
      );
    },
    // A kit still in shipped/delivered with no activated_at has not been
    // activated yet. Treat it as not activated when there is no customer
    // assigned, OR the assigned customer's email is not verified — in both
    // cases there is no usable, confirmed email to contact. Surface a notice
    // and hide the Contact Customer button.
    isNotActivated() {
      if (!this.kits || this.kits.length === 0) return false;
      const kit = this.kits[0];
      return !kit.user || !kit.user.email;
    }
  },
  watch: {
    kit_id(val) {
      if (val && val !== val.toUpperCase()) {
        this.kit_id = val.toUpperCase();
      }
    },
    confirm_kit_id(val) {
      if (val && val !== val.toUpperCase()) {
        this.confirm_kit_id = val.toUpperCase();
      }
    },
    getAdminKits(obj) {
      let kit_id = this.convertKitId(this.getSearchString);
      this.kits = obj;
      if(this.kits.length == 0) {
        this.contactAdminStatus = true;
        this.adminTitle = 'Kit ID is missing';
        this.adminMessage = 'Kit ID '+kit_id+' has been received by the Lab but is not in the SampleTrack database.';
      }else{
        if(this.kits[0].status == 'archive') {
          this.contactAdminStatus = true;
          this.adminTitle = 'Kit ID is archived';
          this.adminMessage = 'Kit ID '+kit_id+' has been received by the Lab but is archived in the SampleTrack database and not available.';
        } else if(this.kits[0].status == 'lab_awaiting') {
          this.contactAdminStatus = false;
          this.adminMessage = 'Kit ID '+kit_id+' has been received by the Lab but there is a problem with sample data retrieval.';
        }
      }
    },
    serverValidation(error) {
      error.forEach(item => {
        this.$validator.errors.add({ field: item.field, msg: item.message });
      });
    },
    pogination(num) {
      this.count_page = num;
    },
  },
  mounted() {
  
  }
};
</script>

<style scoped lang="scss">
@import "../../styles/colors";
.kits {
  margin: 50px 0 0 0;
}
.kits-title {
  display: flex;
  justify-content: space-between;
  margin: 0 0 20px 0;
  padding: 0 30px;
}
.title {
  color: #b3b3b3;
  font-size: 12px;
  font-family: TTNormsMedium, sans-serif;
}
.title.id {
  min-width: 120px;
  width: 100%;
  max-width: 150px;
}
.kit-desc.id {
  min-width: 150px;
  width: 100%;
  max-width: 150px;
  cursor: pointer;
  transition: all 0.5s linear;
}
.kit-desc.id:hover {
  color: #005eb8;
  font-family: TTNormsRegular, sans-serif;
}
.title.status {
  min-width: 170px;
  width: 100%;
  max-width: 170px;
}
.kit-desc.status {
  min-width: 170px;
  width: 100%;
  max-width: 170px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.title.first-name {
  min-width: 130px;
  width: 100%;
  max-width: 150px;
}
.kit-desc.first-name {
  min-width: 150px;
  width: 100%;
  max-width: 150px;
}
.title.last-name {
  min-width: 130px;
  width: 100%;
  max-width: 150px;
}
.kit-desc.last-name {
  min-width: 150px;
  width: 100%;
  max-width: 150px;
}
.title.email {
  min-width: 190px;
  width: 100%;
  max-width: 190px;
}
.kit-desc.email {
  min-width: 190px;
  width: 100%;
  max-width: 190px;
  overflow: hidden;
  padding: 0 5px 0 0;
}
.kit-desc.email span {
  width: 100%;
  max-width: 180px;
  overflow: hidden;
  display: inline-block;
}
.kit-desc.first-name span,
.kit-desc.last-name span {
  width: 100%;
  max-width: 140px;
  overflow: hidden;
  display: inline-block;
}
.title.phone {
  min-width: 150px;
  width: 100%;
  max-width: 150px;
}
.kit-desc.phone {
  min-width: 150px;
  width: 100%;
  max-width: 150px;
}
.title.date {
  min-width: 100px;
  width: 100%;
  position: relative;
//   cursor: pointer;
  max-width: 180px;
}
.title.date2 {
  min-width: 160px;
  width: 100%;
  position: relative;
//   cursor: pointer;
}
.title.date img {
  max-width: 7px;
  height: 14px;
  position: absolute;
  top: -3px;
  right: 5px;
}
.title.date .down {
  transform: rotate(180deg);
}
.kit-desc.date {
  min-width: 160px;
  width: 100%;
}
.kit-desc.button {
  min-width: 160px;
  width: 100%;
}
.kits-item {
  justify-content: space-between;
  position: relative;
  align-items: center;
  padding: 25px 30px;
  background-color: #fff;
  margin: 10px 0;
  border-radius: 5px;
}
.kits-item.custom {
  text-align: center;
  display: ruby block;
}
.btn-align {
  margin-top: 20px;
  text-align: center;
  display: block ruby;
}
.kits-item:hover {
  background-color: #e0e9f4;
}
.kits-item:hover .remove-kit-btn {
  display: block;
}
.kit-desc {
  color: #58595b;
  font-size: 12px;
  font-family: TTNormsLight, sans-serif;
}
.status-line {
  width: 100%;
  max-width: 140px;
  height: 3px;
  background-color: rgba(0, 70, 173, 0.3);
  margin: 5px 0 0 0;
  position: relative;
}
.status-line-bg {
  position: absolute;
  width: 50%;
  content: "";
  left: 0;
  top: 0;
  height: 100%;
  background-color: #005eb8;
}
.pogination {
  margin: 20px 0 0 0;
}
.remove-icon-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border: none;
  padding: 0;
}
.onhold-btn {
  background-color: transparent;
  border: none;
  padding: 0;
  max-width: 15px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  margin: 0 0 0 5px;
  cursor: pointer;
}
.onhold-btn-img {
  max-width: 100%;
}
.onHoldStatus {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.remove-kit-btn {
  display: none;
  position: absolute;
  width: 20px;
  height: 20px;
  border: 1px solid #58595b;
  border-radius: 5px;
  right: 20px;
  cursor: pointer;
  &:before,
  &:after {
    content: "";
    display: block;
    position: absolute;
    height: 1px;
    width: 13px;
    background-color: #58595b;
    top: 50%;
    left: 50%;
    transform: translate(-50%) rotate(45deg);
  }
  &:after {
    transform: translate(-50%) rotate(-45deg);
  }
  &:hover {
    border-color: red;
    &:before,
    &:after {
      background-color: red;
    }
  }
}
@media print {
  .kits {
    display: none;
  }
}
.btn {
  align-items: center;
  justify-content: center;
  outline: none;
  border: 1px solid transparent;
  font-size: 12px;
  font-family: TTNormsLight, sans-serif;
  padding: 6px 15px 6px 15px;
  height: 30px;
  margin: 0 0 0 13px;
  cursor: pointer;
  border-radius: 5px;
}
.btn.search {
  height: 35px;
  min-width: 334px;
  margin: 0px;
}
.btn-test {
  background-color: #005eb8;
  color: #fff;
  max-width: 160px;
  width: 100%;
}
.title {
  color: #1052b2;
  padding: 20px 0 0 0;
  font-size: 16px;
  font-family: TTNormsMedium, sans-serif;
  margin: 0 0 30px 0;
  display: flex;
  position: relative;
  justify-content: space-between;
}
.title.search {
  font-size: 20px;
  margin: 0 0 20px 0;
  display: inherit;
  padding: 0px;
}
.kit-input {
  padding: 0px 5px;
  border: 1px solid transparent;
  outline: none;
  color: #231f20;
  font-size: 14px;
  margin: 0 0 0 5px;
  display: inline-block;
  max-width: 200px;
  width: 100%;
  transition: border 0.3s linear;
  font-family: TTNormsLight, sans-serif;
}
.kit-input.input {
  text-align: center;
}
.item {
  margin: 0 0 25px 0;
  position: relative;
}
.item-title {
  margin: 0 0 14px 0;
  color: #000;
  font-size: 12px;
  font-family: TTNormsMedium, sans-serif;
}
.item-val {
  color: #000;
  font-size: 14px;
  font-family: TTNormsLight, sans-serif;
  position: relative;
}
.date-wrap {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #d9d9d9;
}
.date-wrap2 {
  display: flex;
  justify-content: space-between;
}
.margin-10 {
  margin-top: 10px;
}
.info-block-wrapper {
  width: 100%;
  min-height: 200px;
  box-sizing: border-box;
  padding: 40px 30px;
  display: block;
  justify-content: space-between;
  background-color: $white;
  border-radius: 15px;
  box-shadow: 0 3px 15px -9px $boxShadow;
  font-family: TTNormsRegular, sans-serif;
  color: $gray;
  margin: 10px 0;
  position: relative;
}
.info-block-wrapper.search {
  text-align: center;
}
.input {
  width: 334px;
  padding: 12px 30px;
  border-radius: 10px;
  border: 1px solid #c5c5c5;
  color: $gray;
  font-size: 16px;
  text-align: center;
  text-transform: uppercase;
  outline: none;
  font-family: TTNormsMedium, sans-serif;
}
.textarea {
  width: 100%;
  min-height: 150px;
  padding: 12px 13px;
  border-radius: 10px;
  border: 1px solid #c5c5c5;
  color: $gray;
  font-size: 16px;
  outline: none;
  font-family: TTNormsMedium, sans-serif;
}
.input::placeholder {
  color: $lightGray;
  font-size: 16px;
  text-align: center;
  text-transform: none;
  font-family: TTNormsMedium, sans-serif;
}
.input-wrap {
  margin-bottom: 15px;
  position: relative;
}
.input.invalid {
  border: 1px solid $red;
}
.position {
  position: initial;
}
.btn:disabled {
  cursor: default;
  opacity: 0.5;
}
.or-text {
  font-size: 15px;
}
.no-contact-msg {
  font-size: 15px;
  color: #e87a01;
  font-family: TTNormsMedium, sans-serif;
}
.no-contact-warning {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  color: #8a5200;
  background: #fff4e0;
  border: 1px solid #e87a01;
  border-radius: 6px;
  padding: 8px 12px;
  font-family: TTNormsMedium, sans-serif;
}
.no-contact-warning .warning-icon {
  color: #e87a01;
  font-size: 16px;
  line-height: 1;
}
.not-activated-notice {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 20px 0 0 0;
  font-size: 15px;
  color: #8a5200;
  background: #fff4e0;
  border: 1px solid #e87a01;
  border-radius: 6px;
  padding: 8px 12px;
  font-family: TTNormsMedium, sans-serif;
}
.not-activated-notice .warning-icon {
  color: #e87a01;
  font-size: 16px;
  line-height: 1;
}
</style>
